import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05d6415d&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=05d6415d&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=05d6415d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6415d",
  null
  
)

export default component.exports